import * as Sentry from '@sentry/react';

export type ProposalApplyPhase =
  | 'submit'
  | 'api_error'
  | 'accepted'
  | 'refetch_start'
  | 'refetch_success'
  | 'refetch_error';

export interface ProposalApplyTelemetryContext {
  phase: ProposalApplyPhase;
  workflowId: string | null;
  proposalId: string;
  applyMode: 'full' | 'partial';
  acceptedNodeCount: number | null;
  status?: number;
  errorMessage?: string;
}

export function addProposalApplyBreadcrumb(context: ProposalApplyTelemetryContext): void {
  Sentry.setTag('feature', 'workflow-proposals');
  Sentry.setTag('workflow.id', context.workflowId ?? 'unknown');
  Sentry.setTag('workflow.proposal_id', context.proposalId);
  Sentry.setTag('workflow.proposal.apply_phase', context.phase);
  Sentry.setTag('workflow.proposal.apply_mode', context.applyMode);

  Sentry.setContext('workflow_proposal_apply', {
    phase: context.phase,
    workflowId: context.workflowId,
    proposalId: context.proposalId,
    applyMode: context.applyMode,
    acceptedNodeCount: context.acceptedNodeCount,
    status: context.status,
    errorMessage: context.errorMessage,
  });

  Sentry.addBreadcrumb({
    category: 'workflow-proposals.apply',
    level: context.phase.endsWith('error') ? 'error' : 'info',
    message: context.phase,
    data: {
      phase: context.phase,
      workflowId: context.workflowId,
      proposalId: context.proposalId,
      applyMode: context.applyMode,
      acceptedNodeCount: context.acceptedNodeCount,
      status: context.status,
      errorMessage: context.errorMessage,
    },
  });
}
